/**
 * Reducer for taking search page form state and returning an object of search filters suitable for
 * POSTing to search API endpoint
 * @param formValues
 */
export const getSearchFilters = (formValues: any) => (acc: any, filterKey: string) => {
    if (formValues[filterKey] instanceof Array) {
        return {
            ...acc,
            [filterKey]: formValues[filterKey].map((item: any)  => Object.keys(item).reduce(getSearchFilters(item), {}))
        }
    } else {
        return {
            ...acc,
            [filterKey]: (formValues[filterKey] instanceof Object) ? formValues[filterKey].value : formValues[filterKey]
        }
    }
};